import actionTypes from 'tradera-state/ui/action-types';

export const openModal = payload => ({
    type: actionTypes.OPEN_MODAL,
    payload
});

export const closeModal = () => ({
    type: actionTypes.CLOSE_MODAL
});
